import { Link } from "react-router-dom";

// AuthLink — bronze text link used inside auth screens.
export default function AuthLink({ to, children, onClick, testid }) {
  if (to) {
    return (
      <Link to={to} data-testid={testid}
            className="text-xs hover:underline"
            style={{ color: "#C9A86A" }}>{children}</Link>
    );
  }
  return (
    <button type="button" onClick={onClick} data-testid={testid}
            className="text-xs hover:underline bg-transparent"
            style={{ color: "#C9A86A" }}>{children}</button>
  );
}
